module.exports = __webpack_public_path__ + "static/bmi-app-icon-693e1f840a5de0554404d6577e12071d.png";